export default __webpack_public_path__ + "static/media/forecast.50378a85.jpg";